import React from 'react';

export const partners: PartnerProps[] = [
  {
    partnerName: 'COCARI',
    partnerNumber: 18,
    pageDataCollectionRoute: '/cadastrar/cocari-page-collection',
    pageDataCollectionComponent: React.lazy(() =>
      import('../../Screens/SignUp/Whitelabel/Cocari/PageCollection')
    ),
  },
];

export interface PartnerProps {
  partnerName: string;
  partnerNumber: number;
  pageDataCollectionRoute: string;
  pageDataCollectionComponent?: React.LazyExoticComponent<
    React.ComponentType<any>
  >;
  pagesProps?: {
    icon?: '';
    buttonNext: { color: string };
    address?: { title: string };
  };
}
